module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/jordy-800-5865e44150bd58998370f0544f1e7442.jpg";